import EducationModule from '../../components/education/EducationModule';

export default function EducationPage() {
  return <EducationModule />;
}
